module.exports = __webpack_public_path__ + "static/media/GoLogo@2x.0c391404.png";